
// Loads the signed-in user once (on the server, or on the client after a client-only render) before route
// middleware runs.
export default defineNuxtPlugin(async () => {
    const userStore = useUserStore()
    if (userStore.is_initialized || !useUserSession().loggedIn.value) return

    try {
        await userStore.fetchUser()
    } catch (error) {
        console.error('Could not load the signed-in user', error)
    }
})
